import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

const Input = ({
  type,
  value,
  size,
  className,
  name,
  placeholder,
  isInvalid,
  setRef,
  onChange,
  label,
  errorInputMessage,
  minLength,
  maxLength,
  ...rest
}) => {
  const inputRef = useRef(null)
  var invalidNumberChars = ['-', '+', 'e']
  useEffect(() => {
    if (setRef) {
      setRef(inputRef)
    }
  }, [])

  const handleKeyDown = (e) => {
    const { type } = e.target
    if (type === 'number' && invalidNumberChars.includes(e.key)) {
      e.preventDefault()
    }
  }

  const labelInput = () => (
    <label className={`${styles.labelInput} ${styles[label.position]} ${label.className}`}>{label.name}</label>
  )

  return (
    <React.Fragment>
      {label && label.position === 'top' && labelInput()}
      <input
        type={type}
        ref={inputRef}
        value={value}
        minLength={minLength}
        maxLength={maxLength}
        className={`${styles.input} ${styles[size]} ${className} ${isInvalid && styles.errorInput}`}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        {...rest}
      />
      {label && label.position === 'bottom' && labelInput()}
      {errorInputMessage && (
        <div role='alert' className={styles.errorInputMessage}>
          {errorInputMessage}
        </div>
      )}
    </React.Fragment>
  )
}

Input.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.string,
  isInvalid: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.object,
  errorInputMessage: PropTypes.string,
  minLength: PropTypes.string,
  maxLength: PropTypes.string
}

Input.defaultProps = {
  type: 'text',
  value: '',
  className: '',
  name: '',
  size: 'full',
  placeholder: '',
  isInvalid: false,
  errorInputMessage: '',
  minLength: '',
  maxLength: ''
}

export default Input
